import * as aTypes from "./actionTypes";

export const initFetchContents = () => {
  return {
    type: aTypes.CONTS_INIT,
  };
};

export const setContents = (contents) => {
  return {
    type: aTypes.CONTS_SET,
    contents: contents,
  };
};

export const fetchContentsFailed = (error) => {
  return {
    type: aTypes.CONTS_FAIL,
    error: error,
  };
};

export const setFiltredContents = (filteredContents) => {
  return {
    type: aTypes.CONTS_FILTRED_SET,
    filteredContents: filteredContents,
  };
};
